// Source: app/scripts/controllers/translation.js
Auction.controller('TranslationsController', ['$scope', 'crudService', function ($scope, crudService) {
  var service = crudService('translations', {
    byKey: {
      method: 'GET',
      isArray: true,
      url: '/data/rest/translations/by_key'
    }
  });
  $scope.onInit = function (crudScope) {
    crudScope.languages = crudService('languages').query();
  };

  $scope.beforeSave = function (crudScope, entity) {
    crudScope.entity = {
      key: entity.key
    };
    angular.forEach(crudScope.languages, function (lang) {
      crudScope.entity[lang.name] = entity[lang.name];
    });
    console.log(crudScope.entity);
  };
  $scope.onEdit = function (crudScope, entity) {


    service.byKey({
      key: entity.key
    }, function (data) {
      angular.forEach(data, function (t) {
        crudScope.entity[t.lang.name] = t.value;
      });
    });
  };
}]);
